import { JSX, useEffect, useState } from "react"
import { UserStatisticsDto } from "../types/User"
import UserService from "../Services/UserService";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import { FaChartBar, FaUserCheck, FaUsers, FaUserTimes } from "react-icons/fa";

const UserStatisticCard = () => {

  const [stats, setStats] = useState<UserStatisticsDto | null>(null);
  const [loading, setLoading] = useState(true);

  const loadStatistics = async () => {
    try {
      setLoading(true);
      const data = await UserService.getUserStatistics();
      setStats(data);
    } catch (err: any) {
      console.log(err);
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadStatistics();
  }, []);
  const iconMap: Record<string, JSX.Element> = {
    primary: <FaUsers size={24} />,
    success: <FaUserCheck size={24} />,
    danger: <FaUserTimes size={24} />,
    warning: <FaChartBar size={24} />,
  };

  const StatCard = ({ title, value, color }: { title: string; value: number; color: string; }) => {
    return (
      <Card
        className="border-0 shadow-sm rounded-4 mt-2 h-100"
        style={{
          width: "250px",
          transition: "all 0.25s ease",
          cursor: "default",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <CardBody className="d-flex align-items-center justify-content-between p-3">
          <div>
            <div
              className="text-muted"
              style={{
                fontSize: "0.9rem",
                fontWeight: 500,
              }}
            >
              {title}
            </div>

            <div
              className={`text-${color} fw-bold`}
              style={{
                fontSize: "2rem",
                lineHeight: 1.2,
              }}
            >
              {value}
            </div>
          </div>

          <div
            className={`bg-${color} bg-opacity-10 text-${color} rounded-circle d-flex align-items-center justify-content-center`}
            style={{
              width: 56,
              height: 56,
            }}
          >
            {iconMap[color] ?? <FaChartBar size={24} />}
          </div>
        </CardBody>
      </Card>
    );
  }

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner />
      </div>
    );
  }

  if (!stats) return null;

  return (<>
    <Card className="mb-4 p-4">

      <Row className="d-flex justify-content-center align-items-center ">
        
        
        
        <Col md={3}>
          <StatCard title="Registered Today" value={stats.registeredToday} color="primary" />
        </Col>
        <Col md={3}>
          <StatCard
            title="Registered This Week"
            value={stats.registeredThisWeek}
            color="info"
          />
        </Col>

        <Col md={3}>
          <StatCard
            title="Registered This Month"
            value={stats.registeredThisMonth}
            color="warning"
          />
        </Col>

        <Col md={3}>
          <StatCard
            title="Total Registered"
            value={stats.totalRegistered}
            color="success"
          />
        </Col>

        <Col md={3}>
          <StatCard
            title="Logged In Today"
            value={stats.loggedInToday}
            color="primary"
          />
        </Col>

        <Col md={3}>
          <StatCard
            title="Logged In This Week"
            value={stats.loggedInThisWeek}
            color="info"
          />
        </Col>

        <Col md={3}>
          <StatCard
            title="Logged In This Month"
            value={stats.loggedInThisMonth}
            color="warning"
          />
        </Col>

        <Col md={3}>
          <StatCard
            title="Total Logged In"
            value={stats.totalLoggedIn}
            color="success"
          />
        </Col>
      </Row>



    </Card>
  </>)

}

export default UserStatisticCard